export enum CpapClassOption {
    CpapClassA = 'A: Diagnostisch traject met CPAP of zgn. “Lakmoesproef”',
    CpapClassB = 'B: Niet complexe CPAP-behandeling. Diagnose is duidelijk',
    CpapClassC = 'C: Niet complexe CPAP-behandeling, diagnose is duidelijk: effect van behandeling is niet te voorspellen',
    CpapClassD = 'D: Complexe CPAP-behandeling',
}
